import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

export function useExamCenterCourseListSearchParams() {
  const [{ page, pageSize, sortOrder, sortBy }, setQueryParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString.withDefault('createdAt'),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  return [
    {
      page,
      pageSize,
      sortOrder,
      sortBy,
    },
    { changePageNumber, changePageSize },
  ] as const;
}
